const privacyPolicyLink =
  document.querySelector('[data-privacy-policy-link]') &&
  document.querySelector('[data-privacy-policy-link]').dataset
    .privacyPolicyLink;
const docLang = document.documentElement.lang;
const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
const labels = {
  agree: {
    de: 'Akzeptieren',
    en: 'Accept',
  },
  configure: {
    de: 'Konfigurieren',
    en: 'Configure',
  },
  on: {
    de: 'An',
    en: 'On',
  },
  off: {
    de: 'Aus',
    en: 'Off',
  },
  button: {
    de: 'Speichern & Schließen',
    en: 'Save & Close',
  },
  guidelineTitle: {
    de: 'Ihre Cookie-Einstellungen',
    en: 'Your Cookie Settings',
  },
  guidelineText: {
    de: `Um unsere Website für Sie optimal zu gestalten und fortlaufend zu verbessern, verwenden wir Cookies. Durch Bestätigen des Buttons „Akzeptieren“ stimmen Sie der Verwendung zu. Über den Button „Konfigurieren“ können Sie Ihre Einstellungen anpassen. Sie können jederzeit Ihre Einwilligung widerrufen und Cookies deaktivieren. Weitere Informationen hierzu erhalten Sie in unserer <a href="${privacyPolicyLink}" class="link">Datenschutzerklärung</a>.`,
    en: `We use cookies to optimize our website for you and to improve it continuously. By confirming the button "Accept" you agree to the use of cookies. You can adjust your settings by clicking the "Configure" button. You can revoke your consent at any time and deactivate cookies. For further information, please refer to our <a href="${privacyPolicyLink}" class="link">privacy policy</a>.`,
  },
  configureTitle: {
    de: 'Einstellungen',
    en: 'Settings',
  },
};

/*eslint-disable */
export const cookieBannerTemplate = (showBannerOnRender, isFirstRun, cookieTypes) => (`<section class="cookiebanner ${!showBannerOnRender ? 'is-hidden' : ''}" aria-modal="true" aria-labelledby="cookiebanner-label" tabindex="0">
      <div class="cookiebanner__inner">
          <div class="cookiebanner__intro-panel ${isFirstRun ? '' : 'is-hidden'}">
              <h2 id="cookiebanner-label" tabindex="0">${labels.guidelineTitle[lang]}</h2>
              <p>${labels.guidelineText[lang]}</p>

              <div class="cookiebanner__action-wrapper">
                <button class="btn btn--tertiary cookiebanner__configure"><span>${labels.configure[lang]}</span></button>
                <button class="btn btn--primary cookiebanner__close" data-confirm="all"><span>${labels.agree[lang]}</span></button>
              </div>
          </div>
         <div class="cookiebanner__config-panel ${isFirstRun ? 'is-hidden' : ''}">
            <h2 id="cookiebanner-label" tabindex="0">${labels.configureTitle[lang]}</h2>
            <p>${cookieTypes[0].text[lang]}</p>

            <h3>${cookieTypes[0].name[lang]}</h3>
            <div class="cookiebanner__configure-wrapper">
              <label for="cookie-0" class="cookiebanner__checkbox">
               <input type="checkbox" id="cookie-0" class="sr-only" ${cookieTypes[0].isChecked ? 'checked' : ''}>
                <span class="sr-only">${cookieTypes[0].checkbox[lang]}</span>
                <span class="cookiebanner__toggler" aria-hidden="true"></span>
                <span class="cookiebanner__toggler-text is-on" aria-hidden="true" tabindex="-1">${labels.on[lang]}</span>
                <span class="cookiebanner__toggler-text is-off" aria-hidden="true" tabindex="-1">${labels.off[lang]}</span>
              </label>
              <button class="btn btn--primary cookiebanner__close" data-confirm="select"><span>${labels.button[lang]}</span></button>
            </div>
          </div>
        </div>
      </div>
  </section>
`);

/* eslint-enable */
